import React, { Component } from 'react';

import getSelectField from '../../fields/select';
import getFonts from '../../../Functions/config/fonts';
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";

class Field extends Component {

    constructor(props) {
        super(props);
    }

    setColorsAndPreview = async (type, color) => {
        const { setColorsAndPreview } = this.props;
        await setColorsAndPreview('field', type, color);
    }
    
    setfieldColor = async (color) => {
        await this.setColorsAndPreview('fieldColor', color);
    }

    render(){

        const { widget, handleInputChange, toggleColorPicker } = this.props;
        const { prorated } = widget.htmlData;
        const fontOptions = getFonts();

        return(

            <div className="mjwi-acc-panel-wrapper">

                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>Color</label>
                    </div>
                    <div className='mjwi-col66 mjwi-clr-picker'>
                        
                        <span className="clrPickerVal" onClick={toggleColorPicker} style={{ backgroundColor: prorated.field.fieldColor }}></span>
                        <HexAlphaColorPicker color={prorated.field.fieldColor} onChange={this.setfieldColor} style={{display: "none"}} className="mjwi-apfl-color-picker" />
                        <HexColorInput color={prorated.field.fieldColor} onChange={this.setfieldColor} />
                    </div>
                </div>
                
                <div className='mjwi-row'>    
                    <div className='mjwi-col33'>
                            <label>
                                Font Family
                            </label>                                    
                        </div>
                        <div className='mjwi-col66'>
                            {getSelectField('fieldFontFamily', fontOptions, prorated.field.fieldFontFamily, handleInputChange)}
                        </div>
                </div>

                <div className='mjwi-row'>    
                    <div className='mjwi-col33 mjwi-row'>
                        <label htmlFor="fieldFontSize">Size</label>&nbsp;
                        <input
                            type="number"
                            name="fieldFontSize"
                            value={prorated.field.fieldFontSize}
                            onChange={handleInputChange}
                        />&nbsp;px
                    </div>
                </div>

            </div>

        );
    }
}

export default Field;
